export const hm5VersionListConstants = {
  HM5VERSION_LIST_LOADING: "HM5VERSION_LIST_LOADING",
  HM5VERSION_LIST_SUCCESS: "HM5VERSION_LIST_SUCCESS",
  HM5VERSION_LIST_FAILURE: "HM5VERSION_LIST_FAILURE",
};

export const hm5VersionUploadConstants = {
  HM5VERSION_UPLOAD_LOADING: "HM5VERSION_UPLOAD_LOADING",
  HM5VERSION_UPLOAD_SUCCESS: "HM5VERSION_UPLOAD_SUCCESS",
  HM5VERSION_UPLOAD_FAILURE: "HM5VERSION_UPLOAD_FAILURE",
};

export const hm5VersionConstants = {
  HM5VERSION_LOADING: "HM5VERSION_LOADING",
  HM5VERSION_SUCCESS: "HM5VERSION_SUCCESS",
  HM5VERSION_FAILURE: "HM5VERSION_FAILURE",
};

export const hm5VersionDeleteConstants = {
  HM5VERSION_DELETE_LOADING: "HM5VERSION_DELETE_LOADING",
  HM5VERSION_DELETE_SUCCESS: "HM5VERSION_DELETE_SUCCESS",
  HM5VERSION_DELETE_FAILURE: "HM5VERSION_DELETE_FAILURE",
};
